export default "__VITE_ASSET__CAuITpSK__"